var app = angular.module("myApp", ['ui.bootstrap', 'angular-jwt', 'ngRoute', 'ngCookies', 'ng.deviceDetector', 'imgEditor.directives',
    'ngMessages','ngSanitize', 'ngFileUpload', 'ngCookies', 'signature', 'ng-webcam', 'pascalprecht.translate',
    'angular.filter']);


app.run(
    ['$rootScope','jwtHelper', '$location', '$window', '$http',
    function ($rootScope, jwtHelper, $location, $window, $http) {

    $rootScope.GlobalAlert = function (icon, title, text) {
        return Swal.fire({
            icon: icon,
            title: title,
            text: text,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            backdrop: true,
        })
    };

    $rootScope.AlertYesNo = function (icon, title, text) {
        return Swal.fire({
            icon: icon,
            title: title,
            text: text,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonClass: 'btn btn-success',
            focusConfirm: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: true,
        })
    };

    $rootScope.AlertShowLoading = function (icon, title, text, timer) {
        return Swal.fire({
            icon: icon,
            title: title,
            text: text,
            timer: timer,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showConfirmButton: false,
            //onOpen: () => {
            //    swal.showLoading()
            //}
        })
    };

    $rootScope.AlertShowFooter = function (icon, title, text, textFooter, timer) {
        return Swal.fire({
            footer: textFooter,
            icon: icon,
            title: title,
            text: text,
            timer: timer,
            showConfirmButton: false,
            showCloseButton: true
        })
    };

}]);



app.config(
    ['$provide', '$routeProvider', '$locationProvider', '$httpProvider', 'jwtInterceptorProvider', '$translateProvider',
    function ($provide, $routeProvider, $locationProvider, $httpProvider, jwtInterceptorProvider, $translateProvider) {
    $locationProvider.hashPrefix('');
    $routeProvider.
	when('/',
	{
	    templateUrl: 'template/login.html',
	    controller: 'LoginCtrl'
	}).
    when('/register',
	{
	    templateUrl: 'template/register.html',
	    controller: 'RegisterCtrl'
	}).
    when('/register/:id',
	{
	    templateUrl: 'template/register.html',
	    controller: 'RegisterCtrl'
	}).
    when('/activation/:email',
	{
	    templateUrl: 'template/register.html',
	    controller: 'ActivationCtrl'
	}).
    when('/forgetpassword',
	{
	    templateUrl: 'template/forgetPassword.html',
	    controller: 'forgetPasswordCtrl'
	}).
    when('/change_password/:id',
	{
	    templateUrl: 'template/changePassword.html',
	    controller: 'changePasswordCtrl'
	}).
    when('/login',
	{
	    templateUrl: 'template/login.html',
	    controller: 'LoginCtrl'
	}).
    when('/cif/start',
	{
	    templateUrl: 'template/CIF-KTP.html',
	    controller: 'CIFKTP-CTRL'
	}).
    when('/cif/data-pribadi',
	{
	    templateUrl: 'template/CIF-1.html',
	    controller: 'CIF-CTRL'
	}).
    when('/cif/data-pekerjaan',
	{
	    templateUrl: 'template/CIF-2.html',
	    controller: 'CIF2-CTRL'
	}).
    when('/cif/data-pendukung',
	{
	    templateUrl: 'template/CIF-3.html',
	    controller: 'CIF3-CTRL'
	}).
    when('/cif/data-pernyataan',
	{
	    templateUrl: 'template/CIF-4.html',
	    controller: 'CIF4-CTRL'
	}).
    when('/cif/final',
	{
	    templateUrl: 'template/CIF-Final.html',
	    controller: 'CIFFIN-CTRL'
	}).
    when('/dashboard',
	{
	    templateUrl: 'template/dashboard/dashboard.html',
	    controller: 'CIFDashboard-CTRL'
	}).
    when('/profile',
	{
	    templateUrl: 'template/dashboard/profile.html',
	    controller: 'CIFProfile-CTRL'
	}).
	otherwise(
	{
	    redirectTo: '/logout'
	});

    $translateProvider.useStaticFilesLoader({
        prefix: 'lang/locale-',
        suffix: '.json'
    });

    var $cookies;
    angular.injector(['ngCookies']).invoke(['$cookies', function (_$cookies_) {
        $cookies = _$cookies_;
    }
    ]);

    if (!$cookies.get('lang')) {
        $cookies.put("lang", 'en');
    }
    $translateProvider.preferredLanguage($cookies.get("lang"));
}]);


app.factory('S21Language', function () {
    var lang = '';
    return {
        getLang: function () {
            return lang;
        },

        setLang: function (value) {
            lang = value;
            return value;
        }
    };
});

app.factory('KTPCamService', function () {
    var webcam = {};
    webcam.isTurnOn = false;
    webcam.patData = null;
    var _video = null;
    var _stream = null;
    webcam.patOpts = { x: 0, y: 0, w: 25, h: 25 };
    webcam.channel = {};
    webcam.webcamError = false;

    var getVideoData = function getVideoData(x, y, w, h) {
        var hiddenCanvas = document.createElement('canvas');
        hiddenCanvas.width = _video.width;
        hiddenCanvas.height = _video.height;
        var ctx = hiddenCanvas.getContext('2d');
        ctx.drawImage(_video, 0, 0, _video.width, _video.height);
        return ctx.getImageData(x, y, w, h);
    };

    var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
        webcam.snapshotData = imgBase64;
    };

    webcam.makeSnapshot = function () {
        if (_video) {
            var patCanvas = document.querySelector('#KTPsnapshot');
            if (!patCanvas) return;

            patCanvas.width = _video.width;
            patCanvas.height = _video.height;
            var ctxPat = patCanvas.getContext('2d');

            var idata = getVideoData(webcam.patOpts.x, webcam.patOpts.y, webcam.patOpts.w, webcam.patOpts.h);
            ctxPat.putImageData(idata, 0, 0);

            sendSnapshotToServer(patCanvas.toDataURL());

            webcam.patData = idata;

            webcam.success(webcam.snapshotData.substr(webcam.snapshotData.indexOf('base64,') + 'base64,'.length), 'image/png');
            //webcam.turnOff();
        }
    };

    webcam.onSuccess = function () {
        _video = webcam.channel.video;
        webcam.patOpts.w = _video.width;
        webcam.patOpts.h = _video.height;
        webcam.isTurnOn = true;
    };

    webcam.onStream = function (stream) {
        activeStream = stream;
        console.log('kt', activeStream);
        return activeStream;
    };

    webcam.downloadSnapshot = function downloadSnapshot(dataURL) {
        window.location.href = dataURL;
    };

    webcam.onError = function (err) {
        webcam.webcamError = err;
    };

    webcam.turnOff = function () {
        webcam.isTurnOn = false;
        if (activeStream && activeStream.getVideoTracks) {
            const checker = typeof activeStream.getVideoTracks === 'function';
            if (checker) {
                console.log('ktp', activeStream.getVideoTracks());
                return activeStream.getVideoTracks()[0].stop();
            }
            return false;
        }
        return false;
    };

    var service = {
        webcam: webcam
    };
    return service;
});


app.factory('SELFIECamService', function () {
    var webcam = {};
    webcam.isTurnOn = false;
    webcam.patData = null;
    var _video = null;
    var _stream = null;
    webcam.patOpts = { x: 0, y: 0, w: 25, h: 25 };
    webcam.channel = {};
    webcam.webcamError = false;

    var getVideoData = function getVideoData(x, y, w, h) {
        var hiddenCanvas = document.createElement('canvas');
        hiddenCanvas.width = _video.width;
        hiddenCanvas.height = _video.height;
        var ctx = hiddenCanvas.getContext('2d');
        ctx.drawImage(_video, 0, 0, _video.width, _video.height);
        return ctx.getImageData(x, y, w, h);
    };

    var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
        webcam.snapshotData = imgBase64;
    };

    webcam.makeSnapshot = function () {
        if (_video) {
            var patCanvas = document.querySelector('#SELFIEsnapshot');
            if (!patCanvas) return;

            patCanvas.width = _video.width;
            patCanvas.height = _video.height;
            var ctxPat = patCanvas.getContext('2d');

            var idata = getVideoData(webcam.patOpts.x, webcam.patOpts.y, webcam.patOpts.w, webcam.patOpts.h);
            ctxPat.putImageData(idata, 0, 0);

            sendSnapshotToServer(patCanvas.toDataURL());

            webcam.patData = idata;

            webcam.success(webcam.snapshotData.substr(webcam.snapshotData.indexOf('base64,') + 'base64,'.length), 'image/png');
            //webcam.turnOff();
        }
    };

    webcam.onSuccess = function () {
        _video = webcam.channel.video;
        webcam.patOpts.w = _video.width;
        webcam.patOpts.h = _video.height;
        webcam.isTurnOn = true;
    };

    webcam.onStream = function (stream) {
        activeStream = stream;
        console.log('se', activeStream);
        return activeStream;
    };

    webcam.downloadSnapshot = function downloadSnapshot(dataURL) {
        window.location.href = dataURL;
    };

    webcam.onError = function (err) {
        webcam.webcamError = err;
        console.log('ERR', webcam.webcamError)
    };

    webcam.turnOff = function () {
        webcam.isTurnOn = false;
        if (activeStream && activeStream.getVideoTracks) {
            const checker = typeof activeStream.getVideoTracks === 'function';
            if (checker) {
                console.log('se', activeStream.getVideoTracks());
                return activeStream.getVideoTracks()[0].stop();
            }
            return false;
        }
        return false;
    };

    var service = {
        webcam: webcam
    };


    return service;
});

app.factory('SIGNATURECamService', function () {
    var webcam = {};
    webcam.isTurnOn = false;
    webcam.patData = null;
    var _video = null;
    var _stream = null;
    webcam.patOpts = { x: 0, y: 0, w: 25, h: 25 };
    webcam.channel = {};
    webcam.webcamError = false;

    var getVideoData = function getVideoData(x, y, w, h) {
        var hiddenCanvas = document.createElement('canvas');
        hiddenCanvas.width = _video.width;
        hiddenCanvas.height = _video.height;
        var ctx = hiddenCanvas.getContext('2d');
        ctx.drawImage(_video, 0, 0, _video.width, _video.height);
        return ctx.getImageData(x, y, w, h);
    };

    var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
        webcam.snapshotData = imgBase64;
    };

    webcam.makeSnapshot = function () {
        if (_video) {
            var patCanvas = document.querySelector('#SIGNATUREsnapshot');
            if (!patCanvas) return;

            patCanvas.width = _video.width;
            patCanvas.height = _video.height;
            var ctxPat = patCanvas.getContext('2d');

            var idata = getVideoData(webcam.patOpts.x, webcam.patOpts.y, webcam.patOpts.w, webcam.patOpts.h);
            ctxPat.putImageData(idata, 0, 0);

            sendSnapshotToServer(patCanvas.toDataURL());

            webcam.patData = idata;

            webcam.success(webcam.snapshotData.substr(webcam.snapshotData.indexOf('base64,') + 'base64,'.length), 'image/png');
            //webcam.turnOff();
        }
    };

    webcam.onSuccess = function () {
        _video = webcam.channel.video;
        webcam.patOpts.w = _video.width;
        webcam.patOpts.h = _video.height;
        webcam.isTurnOn = true;
    };

    webcam.onStream = function (stream) {
        activeStream = stream;
        console.log('se', activeStream);
        return activeStream;
    };

    webcam.downloadSnapshot = function downloadSnapshot(dataURL) {
        window.location.href = dataURL;
    };

    webcam.onError = function (err) {
        webcam.webcamError = err;
        console.log('ERR', webcam.webcamError)
    };

    webcam.turnOff = function () {
        webcam.isTurnOn = false;
        if (activeStream && activeStream.getVideoTracks) {
            const checker = typeof activeStream.getVideoTracks === 'function';
            if (checker) {
                console.log('se', activeStream.getVideoTracks());
                return activeStream.getVideoTracks()[0].stop();
            }
            return false;
        }
        return false;
    };

    var service = {
        webcam: webcam
    };


    return service;
});











app.controller('HomeController',
    ['$scope', 'uibDateParser', '$http', '$window', '$location', '$timeout', 'Upload','$q', '$cookies', '$translate', '$filter',
    function ($scope, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $cookies, $translate, $filter) {
    $scope.login = {
        Username: '',
        Password: '',
        Email: '',
        Notelp: '',
    };

    $scope.login_status = false;

    $scope.languages = [
       {
           lang: 'en',
           name: 'English',
       },
       {
           lang: 'id',
           name: 'Indonesia'
       }
    ];

    $scope.languageSelected = $scope.languages[0];
    //$scope.language = 'en';

    $scope.updateLanguage = function (lang) {
        if (lang == 'id')
            $scope.languageSelected = $scope.languages[1];
        else
            $scope.languageSelected = $scope.languages[0];
        $translate.use($scope.languageSelected.lang);

        $cookies.put("lang", $scope.languageSelected.lang);

        $timeout($scope.checkLanguange, 10);
        //$scope.checkLanguange();
    };

    $scope.checkLanguange = function () {
        //leng setup dynamic
        let BankRDN = $scope.broker.BankRDN.join(", ");
        let CompanyName = $scope.broker.BROKERName;
        let Mail = $scope.broker.Mail;
        $scope.REGIS = {
            faqrequired3: $filter('translate')('REGIS.faqrequired3').replace(/COMPANYPED/g, CompanyName),

            faq1: $filter('translate')('REGIS.faq1').replace(/COMPANYPED/g, CompanyName),
            faq6: $filter('translate')('REGIS.faq6').replace(/COMPANYPED/g, CompanyName),
            faqKTP: $filter('translate')('REGIS.faqKTP').replace(/COMPANYPED/g, CompanyName),
            faq2answer1: $filter('translate')('REGIS.faq2answer1').replace(/COMPANYPED/g, CompanyName),
            faq3answer1: $filter('translate')('REGIS.faq3answer1').replace(/COMPANYPED/g, CompanyName),
            faq4answer2: $filter('translate')('REGIS.faq4answer2').replace(/COMPANYPED/g, CompanyName),
            faq4answer3: $filter('translate')('REGIS.faq4answer3').replace(/COMPANYPED/g, CompanyName),
            faq5answer1: $filter('translate')('REGIS.faq5answer1').replace(/COMPANYPED/g, CompanyName),
            faq6answer1: $filter('translate')('REGIS.faq6answer1').replace(/COMPANYPED/g, CompanyName),
            faqrequired3: $filter('translate')('REGIS.faqrequired3').replace(/COMPANYPED/g, CompanyName),


            faq5answer3: $filter('translate')('REGIS.faq5answer3').replace(/MAILPED/g, Mail),
        };

        $scope.CIF = {
            terms: $filter('translate')('CIF.terms').replace(/COMPANYPED/g, CompanyName),
        }
    }

    var allPromise = $q.all([
        $http({
            method: 'GET',
            url: 'service/client.svc/GetPED',
        }).then(function (data) {

            if (data.data.d != null) {
                $scope.broker = data.data.d;
                $scope.checkLanguange();
            }
        }, function (error) { }),

    ]);

    $scope.signout = function () {
        $http({
            method: 'POST',
            url: 'service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login_user";
                $window.location.reload();
            }
        }, function (error) { })
    };

        // dengan sweet alert confirmation dialog sebelum logout
    $scope.signOutWithConf = function () {

        var SWALtranslate = $scope.SWALtranslate('logoutConf');

        $rootScope.AlertYesNo('question', SWALtranslate.title, SWALtranslate.message)
        .then((result) => {
            if (result.value) {

                $scope.signOut();
            }
        });
    }

        // the dynamic post or get sweet alert 2 
    $scope.PostGetSwal = function (preconfirmtranslate, urlsvc, postData, method, callback) {

        var SWALtranslate = $scope.SWALtranslate(preconfirmtranslate);

        return Swal.fire({
            icon: 'question',
            title: SWALtranslate.title,
            text: SWALtranslate.message,
            footer: 'Harap Menunggu, Jangan Tutup Browser Anda',
            showCancelButton: true,
            confirmButtonColor: '#3a3963',
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            preConfirm: (preConf) => {

                return $http({
                    method: method,
                    url: urlsvc,
                    data: postData
                }).then(data => {


                    if (data.data.d.result) {

                        var SWALtranslate = $scope.SWALtranslate(data.data.d.message);

                        Swal.fire({
                            title: SWALtranslate.title,
                            text: SWALtranslate.message,
                            icon: "success",
                            showConfirmButton: false,
                            timer: 3000,
                        })

                    } else {

                        var SWALtranslate = $scope.SWALtranslate(data.data.d.message);

                        //Swal.showValidationMessage(
                        //   SWALtranslate.message
                        //)
                        if (data.data.d.resultCode) {

                            callback(data.data.d); // send /return callback to .js
                            return;
                        }

                        Swal.fire({
                            title: SWALtranslate.title,
                            text: SWALtranslate.message,
                            icon: "error",
                            showConfirmButton: true,
                        })
                        return false;
                    }

                    callback(data.data.d); // send /return callback to .js
                })
              .catch(error => {
                  Swal.showValidationMessage(
                      "There is a problem connecting to the server. \
                        Please ensure your internet connection is active. If the problem persists, please try again later."
                  )
                  console.log(`Request failed: ${error}`)
              })
            }
        })
    };

    $scope.checkLogin = function () {

        $http({
            method: 'POST',
            url: '/service/client.svc/retrieveSession',
        }).then(function (data) {
            if (data.data.d) {

                $scope.checkLoginStep(data.data.d);
                console.log(data.data.d)
            }
        }, function (error) { })
    }

        // check login step
    $scope.checkLoginStep = function (userSession) {

        // stage: finished
        if (userSession.IsFinished == 1) {
            $window.location.href = "#/dashboard";
            $window.location.reload();
        }

        // stage: 1
        if (userSession.Stage) {
            if (userSession.Stage == 1) {

                // stage: 1 and revised
                if (userSession.IsRevised == 1) {
                    $window.location.href = "#/dashboard";
                    $window.location.reload();
                } else {

                    $window.location.href = "#/cif/data-pribadi";
                    $window.location.reload();
                }
            }

            // stage: 2
            if (userSession.Stage == 2) {
                $window.location.href = "#/cif/data-pekerjaan";
                $window.location.reload();
            }

            // stage: 3
            if (userSession.Stage == 3) {
                $window.location.href = "#/cif/data-pendukung";
                $window.location.reload();
            }

            // stage: 4
            if (userSession.Stage == 4) {

                // stage: 4 and finished
                if (userSession.IsFinished == 1) {
                    $window.location.href = "#/dashboard";
                    $window.location.reload();
                } else {
                    $window.location.href = "#/cif/data-pernyataan";
                }

                // stage: 4 and revised
                if (userSession.IsRevised == 1) {
                    $window.location.href = "#/dashboard";
                    $window.location.reload();
                }
            }
        }
    }

        // scope untuk mengecek session saja
        // jika tidak ada session maka trigger $scope.signOut
    $scope.retrieveSessions = function () {

        $http({
            method: 'POST',
            url: '/service/client.svc/retrieveSession',
        }).then(function (data) {
            if (!data.data.d) {

                $scope.signOut();
            }
            else
                $scope.currentUser = data.data.d;
            console.log($scope.currentUser)
        }, function (error) { })
    }
    //$scope.getDateString = function (jsonDate) {
    //    if (jsonDate == undefined) {
    //        return "";
    //    }
    //    var utcTime = parseInt(jsonDate.substr(6));
    //    return utcTime;
    //}

    // kumpulan sweet alert translate untuk di lempar di ui sweet alert-- title, message, footer
    $scope.SWALtranslate = function (translateLocale) {

        var result = [];

        switch (translateLocale) {
            case 'logoutConf':

                result.title = $filter('translate')('INFO.logout');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitregistrationconf':

                result.title = $filter('translate')('INFO.submitregistration');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitregistrationsuccess':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.submitregistrationsuccess');
                break;
            case 'emailduplicate':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.emailduplicate') + $scope.user.Email;
                break;
            case 'emailnotfound':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.emailnotfound');
                break;
            case 'bcagagal':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.bcagagal');
                break;
            case 'savedatasuccess':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.succcessdatasave');
                break;
            case 'profilenotfound':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.profilenotfound');
                break;
            case 'SaveFailed':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.SaveFailed');
                break;
            case 'submitCif1':

                result.title = $filter('translate')('INFO.submitcif1');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitCif2':

                result.title = $filter('translate')('INFO.submitcif2');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitCif3':

                result.title = $filter('translate')('INFO.submitcif3');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitCif4':

                result.title = $filter('translate')('INFO.submitcif4');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitPhoto':

                result.title = $filter('translate')('INFO.submitcifphoto');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitCif4success':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.submitcif4success');
                break;
            case 'logindisabled':

                result.title = $filter('translate')('INFO.loginfailed');
                result.message = $filter('translate')('INFO.notactivated');
                break;
            case 'notactivated':

                result.title = $filter('translate')('INFO.loginfailed');
                result.message = $filter('translate')('INFO.notactivated');
                result.footer = $filter('translate')('INFO.clicktoresendactivationlink');
                break;
            case 'wronguserpass':

                result.title = $filter('translate')('INFO.loginfailed');
                result.message = $filter('translate')('INFO.wronguserpass');
                break;
            case 'resendactivated':

                result.title = $filter('translate')('INFO.loginfailed');
                result.message = $filter('translate')('INFO.resendactived');
                break;
            case 'maxlogin':

                result.title = $filter('translate')('INFO.loginfailed');
                result.message = $filter('translate')('INFO.maxlogin');
                break;
            case 'aggreement1':

                result.title = $filter('translate')('INFO.aggreement1');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'aggreement2':

                result.title = $filter('translate')('INFO.aggreement2');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'aggreement3':

                result.title = $filter('translate')('INFO.aggreement3');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'forgetpasswordsuccess':

                result.title = $filter('translate')('INFO.forgetpasswordsuccess');
                result.message = $filter('translate')('INFO.checkyouremail');
                break;
            case 'changepasswordconf':

                result.title = $filter('translate')('INFO.conf');
                result.message = $filter('translate')('INFO.changepasswordconf');
                break;
            case 'changepasswordsuccess':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.changepasswordsuccess');
                break;
            case 'sendforgetpassword':

                result.title = $filter('translate')('INFO.sendchangepasswordlink');
                result.message = $filter('translate')('INFO.sureForgetPasword');
                break;
            case 'activationsuccess':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.activationsuccess');
                break;
            case 'resendactivationlink':

                result.title = $filter('translate')('INFO.resendactivationlink');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'otpsent':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.resendactivationlinksuccess');
                break;
            case 'preparationinfouploadphotocif1':

                result.title = $filter('translate')('INFO.uploadphoto');
                result.message = $filter('translate')('INFO.preparationinfouploadphoto');
                break;
            case 'ocr':

                result.title = $filter('translate')('INFO.ocrl');
                result.message = $filter('translate')('INFO.ocrt');
                break;
            case 'wronguserpassword':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.wronguserpassword');
                break;
            case 'preparationinfouploadphotocif1':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.logindisabled');
                break;
            case 'preparationinfouploadphotocif1':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.notactivated');
                break;
            case 'changepasswordfailed':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.changepasswordfailed');
                break;
            case 'actioncaptcha':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.actioncaptcha');
                break;
            case 'remindercaptcha':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.remindercaptcha');
                break;
            case 'alreadyemail':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.emailduplicate');
                break;
            case 'submitocr':

                result.title = $filter('translate')('INFO.sure');
                result.message = $filter('translate')('INFO.submitocr');
                break;
            case 'wrongocr':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.wrongocr');
                break;
            case 'uploadsuccess':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.uploadsuccess');
                break;
            case 'maximumdayocr':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.maximumdayocr');
                break;
            case 'alreadyktp':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.alreadyktp');
                break;
            default:

                result.title = "Update Needed";
                result.message = "Needed to update the apps.js";
                break;
        }
        return result;
    }


    allPromise.then(function () {
        if (!$cookies.get('lang'))
            $cookies.put("lang", 'en');
        else
            $scope.updateLanguage($cookies.get('lang'));

    });


    app.directive('numericOnly', function ($filter) {
        return {
            require: '?ngModel',
            link: function (scope, elem, attrs, ctrl) {
                if (!ctrl) {
                    return;
                }

                ctrl.$formatters.unshift(function () {
                    return $filter('number')(ctrl.$modelValue);
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    var plainNumber = viewValue.replace(/[^\d]/g, ''),
                        b = $filter('number')(plainNumber);

                    elem.val(b);
                    if (plainNumber == '') {
                        plainNumber = 0;
                    }
                    return parseInt(plainNumber);
                });
            }
        };
    });

    app.directive('textOnly', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {

                    if (text) {

                        var transformedInput = text.replace(/[^A-Za-z\' \s]/g, '');

                        //if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                        //}
                        return transformedInput;
                    }
                    return undefined;
                }
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });

    app.directive('numbersOnly', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text.replace(/[^0-9]/g, '');

                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    return undefined;
                }
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });


    app.directive('onlyNumbers', function () {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs, ctrl) {
                elm.on('keydown', function (event) {
                    if (event.shiftKey) { event.preventDefault(); return false; }
                    //console.log(event.which);
                    if ([8, 13, 27, 37, 38, 39, 40].indexOf(event.which) > -1) {
                        // backspace, enter, escape, arrows
                        return true;
                    } else if (event.which >= 48 && event.which <= 57) {
                        // numbers 0 to 9
                        return true;
                    } else if (event.which >= 96 && event.which <= 105) {
                        // numpad number
                        return true;
                    }
                        // else if ([110, 190].indexOf(event.which) > -1) {
                        //     // dot and numpad dot
                        //     return true;
                        // }
                    else {
                        event.preventDefault();
                        return false;
                    }
                });
            }
        }
    });





        //$http({
        //    method: 'GET',
        //    url: 'service/client.svc/GetPED',
        //}).then(function (data) {

        //    if (data.data.d != null) {
        //        //$scope.user.BrokerCode = $scope.broker.BROKERCode;
        //        console.log($scope.broker.BROKERCode)
        //    }
        //}, function (error) {
        //    console.log('not found')
        //})
}]);


app.controller('CameraController', function ($scope, $uibModalInstance, items, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $cookies, $translate) {

    $scope.items = items;
    $scope.camfacing = 'env';
    $scope.ktpPhoto = '';
    $scope.statusCamera = 'true';
    //var height = 550;
    //var width = 420;

    $scope.KTPconfig = {
        //viewerWidth: 426,
        //viewerHeight: 320,
        //outputWidth: 213,
        //outputHeight: 160,
        delay: 0,
        shots: 1,
        countdown: 0,
        flashFallbackUrl: 'vendors/webcamjs/webcam.swf',
        shutterUrl: 'shutter.mp3',
        flashNotDetectedText: 'Camera not found or use Chrome Browser'
    };

    $scope.switchCam = function () {
        console.log($scope.camfacing);
        if ($scope.camfacing == 'env') {
            console.log('cam1');
            $scope.$broadcast('ngWebcam_camUsr');
            $scope.camfacing = 'usr'
        }
        else {
            console.log('cam2');
            $scope.$broadcast('ngWebcam_camEnv');
            $scope.camfacing = 'env'
        }

        console.log($scope.camfacing);
    }

    $scope.KTPonCaptureComplete = function (src) {
        console.log(src);
        $scope.ktpPhoto = src[0];
        $uibModalInstance.close($scope.ktpPhoto);
        //var el = document.getElementById('result');
        //var img = document.createElement('img');
        //img.src = src[$scope.KTPconfig.shots - 1];
        //img.width = 240;
        //img.height = 180;
        //el.appendChild(img);
    };

    $scope.KTPonError = function (err) {
        console.log('webcamController.onError : ', err);
        $scope.statusCamera = '';
    };

    $scope.KTPonLoad = function () {
        // $log.info('ktp.onLoad');
    };

    $scope.KTPcapture = function () {
        $scope.$broadcast('ngWebcam_capture');
    };

    $scope.KTPon = function () {
        $scope.$broadcast('ngWebcam_on');
    };

    $scope.KTPoff = function () {
        $scope.$broadcast('ngWebcam_off');
        $scope.captureButtonEnable = false;
    };

    $scope.KTPremove = function () {
        $scope.ktpPhoto = '';
    }





    $scope.ok = function () {
        $uibModalInstance.close($scope.item);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };



});

app.controller('BrowseController',
    ['$scope', '$uibModalInstance', 'items', 'uibDateParser', '$http', '$window', '$location', '$timeout', 'Upload', '$q', '$cookies', '$translate',
    function ($scope, $uibModalInstance, items, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $cookies, $translate) {

    $scope.items = items;
    $scope.allowedExt = ['.jpg', '.jpeg', '.bmp', '.png'];


    $scope.filenameKTP = "";
    $scope.fileKTP = "";
    $scope.fileKTPext = "";
    $scope.KTPFile = [];



    $scope.selectKTP = function (files) {

        if (files.length > 0) {
            console.log('files', files);
            $scope.KTPFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {
                if (allowed) {
                    $scope.fileKTP = btoa(e.target.result.toString());
                    $uibModalInstance.close($scope.fileKTP);
                }
            };
            console.log('gambar', $scope.KTPFile);
            reader.readAsBinaryString(files[0]);
            $scope.fileKTPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

            if ($scope.allowedExt.indexOf($scope.fileKTPext.toLowerCase()) < 0) {
                allowed = false;
                $scope.fileKTPext = '';
                $scope.KTPFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            }
            else
                $scope.filenameKTP = files[0].name;
        }
        else
            console.log('file not found');
    };


    $scope.clickRemoveKTP = function (file, event, key) {
        event.preventDefault();
        $scope.fileKTP = "";
        $scope.filenameKTP = "";
        $scope.fileKTPext = "x";
        $scope.KTPFile.splice(key, 1);
        $scope.KTPFile = [];
        return null;
    };
}]);



// app.directive('input', function($sanitize) {
//     return {
//       restrict: 'E',
//       require: '?ngModel',
//       link: function (scope, element, attrs, ngModel) {
//         if(ngModel !== undefined){
//           ngModel.$parsers.push(function(value){
//             return $sanitize(value);
//           });
//         }
//       }
//     };
//   });

  
// app.directive('input', function ($filter, $sanitize) {
//     return {
//         require: '?ngModel',
//         link: function (scope, elem, attrs, ctrl) {
//             if (!ctrl) {
//                 return;
//             }

//             ctrl.$formatters.push(function (inputValue) {
//                 if (!inputValue || attrs.type!="text") {
//                     return;
//                 }
                
//                 console.log(attrs);
//                 var transformedInput = $sanitize(inputValue);

//                 if (transformedInput != inputValue) {
//                     ctrl.$setViewValue(transformedInput);
//                     ctrl.$render();
//                 }   

//                 return transformedInput;


//             });
//         }
//     };
// });




app.directive('numericOnly', function ($filter) {
    return {
        require: '?ngModel',
        link: function (scope, elem, attrs, ctrl) {
            if (!ctrl) {
                return;
            }

            ctrl.$formatters.unshift(function () {
                return $filter('number')(ctrl.$modelValue);
            });

            ctrl.$parsers.unshift(function (viewValue) {
                var plainNumber = viewValue.replace(/[^\d]/g, ''),
                    b = $filter('number')(plainNumber);

                elem.val(b);
                if (plainNumber == '') {
                    plainNumber = 0;
                }
                return parseInt(plainNumber);
            });
        }
    };
});

app.directive('textOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {

                if (text) {

                    var transformedInput = text.replace(/[^A-Za-z\' \s]/g, '');

                    //if (transformedInput !== text) {
                    ngModelCtrl.$setViewValue(transformedInput);
                    ngModelCtrl.$render();
                    //}
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});

app.directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});


app.directive('onlyNumbers', function () {
    return {
        restrict: 'A',
        link: function (scope, elm, attrs, ctrl) {
            elm.on('keydown', function (event) {
                if (event.shiftKey) { event.preventDefault(); return false; }
                //console.log(event.which);
                if ([8, 13, 27, 37, 38, 39, 40].indexOf(event.which) > -1) {
                    // backspace, enter, escape, arrows
                    return true;
                } else if (event.which >= 48 && event.which <= 57) {
                    // numbers 0 to 9
                    return true;
                } else if (event.which >= 96 && event.which <= 105) {
                    // numpad number
                    return true;
                }
                    // else if ([110, 190].indexOf(event.which) > -1) {
                    //     // dot and numpad dot
                    //     return true;
                    // }
                else {
                    event.preventDefault();
                    return false;
                }
            });
        }
    }
});

angular.module('myApp.directives', [])
    .directive('ngThumb', ['$window',
        function ($window) {
            var helper = {
                support: !!($window.FileReader && $window.CanvasRenderingContext2D),
                isFile: function (item) {
                    return angular.isObject(item) && item instanceof $window.File;

                },
                isImage: function (file) {
                    var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                    return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
                }
            };
            return {
                restrict: 'A',
                template: '<canvas/>',
                link: function (scope, element, attributes) {
                    if (!helper.support) return;

                    var params = scope.$eval(attributes.ngThumb);

                    if (!helper.isFile(params.file)) return;
                    if (!helper.isImage(params.file)) return;

                    var canvas = element.find('canvas');
                    var reader = new FileReader();

                    reader.onload = onLoadFile;
                    reader.readAsDataURL(params.file);

                    function onLoadFile(event) {
                        var img = scope.img = new Image();
                        img.onload = onLoadImage;
                        img.src = event.target.result;
                    }

                    function onLoadImage() {
                        var width = params.width || this.width / this.height * params.height;
                        var height = params.height || this.height / this.width * params.width;
                        canvas.attr({
                            width: width,
                            height: height
                        });
                        canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
                    }
                }
            };
        }
    ]);

